var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.label,"inset":_vm.inset,"hide-details":_vm.hideDetails},on:{"change":_vm.emitChange},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }